import type { ReactNode } from 'react';

import './ApplicationBanner.css';

interface ApplicationBannerRegionProps {
  children: ReactNode;
  'data-testid'?: string;
}

/**
 * Shared placement and stacking region for application-wide informational
 * banners. Render this once in the authenticated application layout.
 */
export function ApplicationBannerRegion({
  children,
  'data-testid': dataTestId = 'application-banner-region',
}: ApplicationBannerRegionProps) {
  return (
    <div
      className='application-banner-region'
      data-testid={dataTestId}>
      {children}
    </div>
  );
}

export default ApplicationBannerRegion;
